import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  IceCream, ChevronRight, BookOpen,
  FileText, Cookie, BadgeCheck,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleVerifyClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      document.getElementById('verify-certificate')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#verify-certificate');
      setTimeout(() => {
        document.getElementById('verify-certificate')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand-section">
            <Link
              to="#"
              className="footer-brand"
              onClick={e => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            >
              <div className="footer-logo">
                <IceCream size={20} color="white" />
              </div>
              <span className="footer-title">Glacio</span>
            </Link>
            <p className="footer-description">
              {t('footer.description')}
            </p>
            {/* <div className="footer-social">
              <button className="social-link" aria-label="Discord" onClick={() => {}}>
                <MessageCircle size={18} />
              </button>
              <button className="social-link" aria-label="Facebook" onClick={() => {}}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </button>
            </div> */}
          </div>

          <div className="footer-column">
            <h4 className="footer-column-title">{t('footer.columns.product')}</h4>
            <ul className="footer-column-links">
              <li><Link to="/products"><ChevronRight size={14} /> {t('footer.links.features')}</Link></li>
              <li><Link to="/certificates"><ChevronRight size={14} /> {t('footer.links.smartContracts')}</Link></li>
              <li><a href="#verify-certificate" onClick={handleVerifyClick}><BadgeCheck size={14} /> {t('nav.verify')}</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-column-title">{t('footer.columns.legal')}</h4>
            <ul className="footer-column-links">
              <li><Link to="/privacy"><FileText size={14} /> {t('footer.links.privacyPolicy')}</Link></li>
              <li><Link to="/terms"><FileText size={14} /> {t('footer.links.terms')}</Link></li>
              <li><Link to="/cookies"><Cookie size={14} /> {t('footer.links.cookies')}</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-column-title">{t('footer.columns.support')}</h4>
            <ul className="footer-column-links">
              <li><Link to="/blogs"><BookOpen size={14} /> {t('footer.links.blog')}</Link></li>
              <li><Link to="/contact"><ChevronRight size={14} /> {t('footer.links.contactUs')}</Link></li>
              <li><Link to="/troubleshoot"><ChevronRight size={14} /> {t('footer.links.troubleshoot')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
}
